function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import request from '@/utils/request';

/**
 * 获取订单 列表
 * @param prams
 */
export function goodsList(params) {
  return request({
    url: '/admin/merchant/store/product/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取商品分类
 * @param params
 */
export function getGoodsCategory(params) {
  return request({
    url: '/admin/merchant/category/tree',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      type: 1
    })
  });
}

/**
 * 获取展示分类
 * @param params
 */
export function getDisplayCategory(params) {
  return request({
    url: '/admin/merchant/category/tree',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      type: 8
    })
  });
}

/**
 * 新增商户商品
 * @param data
 */
export function createMerchantProduct(data) {
  return request({
    url: '/admin/merchant/store/product/save',
    method: 'post',
    data: data
  });
}

/**
 * 修改商户商品
 * @param data
 */
export function updateMerchantProduct(data) {
  return request({
    url: '/admin/merchant/store/product/update',
    method: 'post',
    data: data
  });
}

/**
 * 修改商品状态
 * @param id
 * @param status
 */
export function updateProductStatus(id, status) {
  return request({
    url: "/admin/merchant/store/product/status/".concat(id, "/").concat(status),
    method: 'get'
  });
}

/**
 * 删除商户商品
 * @param id
 */
export function deleteMerchantProduct(id) {
  return request({
    url: "/admin/merchant/store/product/delete/".concat(id),
    method: 'get'
  });
}

// 删除商户下所有的同步数据
export function deleteMerchantAllSyncData(id) {
  return request({
    url: "/admin/merchant/store/product/sync/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 获取同步数据店铺关联的同步数据店铺
 * @param spuCode
 */
export function getStoreIdsBySpuCode(spuCode) {
  return request({
    url: "/admin/merchant/Store/getStoreIdsBySpuCode/".concat(spuCode),
    method: 'get'
  });
}

/**
 * 获取品牌列表
 * @param params
 */
export function getBrand(params) {
  return request({
    url: '/admin/merchant/brand/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 获取商户店铺列表
 * @param params
 */
export function getStore(params) {
  return request({
    url: '/admin/merchant/Store/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 获取商户商品标签
 * @param params
 */
export function getLabel(params) {
  return request({
    url: '/admin/merchant/label/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 新增商户商品标签
 * @param params
 * {
	"createTime": "",
	"id": 0,
	"labelName": "",
	"status": 1,
	"supplierId": 0,
	"updateTime": ""
}
 */
export function createLabel(data) {
  return request({
    url: '/admin/merchant/label/create',
    method: 'post',
    data: data
  });
}

/**
 * 获取所有规格列表
 * @param params
 */
export function getRules(params) {
  return request({
    url: '/admin/merchant/rule/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 获取商户商品详情
 * @param params
 */
export function getMerchantProductInfo(id) {
  return request({
    url: "/admin/merchant/store/product/info/".concat(id),
    method: 'get'
  });
}

/**
 * 获取配送设置列表
 * @param params
 */
export function getDeliverySettingList(params) {
  return request({
    url: '/admin/merchant/delivery/setting/list',
    method: 'get',
    params: params
  });
}

/**
 * 创建配送设置
 * @param data
 */
export function createDeliverySetting(data) {
  return request({
    url: '/admin/merchant/delivery/setting/create',
    method: 'post',
    data: data
  });
}

/**
 * 更新配送设置
 * @param data
 */
export function updateDeliverySetting(data) {
  return request({
    url: '/admin/merchant/delivery/setting/update',
    method: 'post',
    data: data
  });
}

/**
 * 删除配送设置
 * @param id
 */
export function deleteDeliverySetting(id) {
  return request({
    url: "/admin/merchant/delivery/setting/delete/".concat(id),
    method: 'delete'
  });
}

/**
 * 更新商户商品状态
 * @param id 商品ID
 * @param merchantStatus 商户状态 0-下架 1-上架
 */
export function updateProductMerchantStatus(id, merchantStatus) {
  return request({
    url: "/admin/merchant/store/product/merchantStatus/".concat(id, "/").concat(merchantStatus),
    method: 'get'
  });
}

/**
 * 获取购买方式列表
 */
export function getWmTgFlagList(storeId) {
  return request({
    url: '/admin/merchant/Store/getWmTgFlagList',
    method: 'get',
    params: {
      storeId: storeId
    }
  });
}

// 物流运费模板下拉框
export function shippingDropList(data) {
  return request({
    url: 'admin/express/shipping/templates/dropList',
    method: 'get',
    params: data
  });
}